module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-calabria-arte-contemporanea.svg?8c81d613495aa98616e24c96c549b065";